import { Injectable } from '@angular/core';
import { Customer, User } from '../../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private token!: string;
  private user!: User;
  private customer!: Customer;
  private portal_user_id!: string;
  private company_status!: string;

  constructor() { }

  get Token() {
    return this.token;
  }

  set Token(token: string) {
    this.token = token;
  }

  get User() {
    return this.user;
  }

  set User(user: User) {
    this.user = user;
  }

  get Customer() {
    return this.customer;
  }

  set Customer(customer: Customer) {
    this.customer = customer;
  }

  get PortalUserId() {
    return this.portal_user_id;
  }

  set PortalUserId(portal_user_id: string) {
    this.portal_user_id = portal_user_id;
  }

  get CompanyStatus() {
    return this.company_status;
  }

  set CompanyStatus(company: any) {
    this.company_status = company.status?.key_string || 'company-debt';
  }
}
